"use client";

import uploadFile from "@/core/utils/upload-file";
import { handleCreateForm } from "@/features/form-functions";
import { toast } from "sonner";
import { useCreateFormStore } from "@/core/stores";
import { defaultAgentImage } from "@/core/types";
import { useRouter } from "next/navigation";
import { useReadMyForms } from "./use-read-my-forms";

export function useCreateForm() {
  const {
    name,
    firstMessage,
    lastMessage,
    agent,
    color,
    blocks,
    loading,
    disabled,
    setDisabled,
    setName,
    setLoading,
    setFirstMessage,
    setLastMessage,
    setAgentName,
    setAgentFile,
    setColor,
    addBlock,
    removeBlock,
    updateBlock,
    resetAll,
  } = useCreateFormStore();
  const router = useRouter();
  const { readForms } = useReadMyForms();

  const getFileData = async (): Promise<string> => {
    if (!agent.file) return defaultAgentImage;
    const randomePathName = Math.random().toString(36).substring(7);
    const { fileURL, error } = await uploadFile(
      agent.file,
      randomePathName,
      "agent-images"
    );

    if (error) {
      console.error(error);
      return defaultAgentImage;
    }
    if (!fileURL) return defaultAgentImage;
    return fileURL;
  };

  const createForm = async () => {
    if (disabled) return;
    try {
      setLoading(true);
      const fileUrl = await getFileData();
      const revertedBlocksOptional = blocks.map((block) => {
        return {
          ...block,
          optional: block.optional === true ? false : true,
        };
      });
      const res = await handleCreateForm(
        name,
        agent.name,
        fileUrl,
        color || "#000000",
        revertedBlocksOptional,
        lastMessage.checked ? lastMessage.message : undefined,
        firstMessage.message
      );
      if (res.error) {
        alert(res.error);
        console.error(res.error);
        return;
      }
      router.push(`/form/${res.form?.id}/results?is_new=true`);
      toast("폼이 성공적으로 생성되었어요!.");
      readForms();
      resetAll();
    } catch (e) {
      console.error(e);
      alert("Error creating form");
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    setName,
    agent,
    name,
    setLastMessage,
    setFirstMessage,
    setAgentName,
    setAgentFile,
    setColor,
    createForm,
    addBlock,
    removeBlock,
    updateBlock,
    blocks,
    firstMessage,
    lastMessage,
    color,
    disabled,
    setDisabled,
    resetAll,
  };
}
